import React from "react";
// import Masonry from 'react-masonry-component';
import "flatpickr/dist/themes/light.css";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import Flatpickr from "react-flatpickr";
import { addQueryString, qsToObject, isRTL, masonryOptions } from "./utils";
import Select from "react-select";

const isLoggedIn =
  document.querySelector("#UserLoginStatus") &&
  document.querySelector("#UserLoginStatus").value === "False";
const WhatsOnListingClasses = ({
  articleListing,
  dealsListing,
  whatsonListing,
  pressReleaseListing,
  tabList,
  changeTab,
}) => {
  const [response, setresponse] = React.useState();
  const [hits, sethits] = React.useState();
  const [date, setdate] = React.useState();
  const [hideLoadMore, sethideLoadMore] = React.useState(false);
  const [showLoader, setshowLoader] = React.useState(false);
  const [updateFilters, setupdateFilters] = React.useState(false);
  const [showSearchError, setshowSearchError] = React.useState(false);

  const [displayFilters, setDisplayFilters] = React.useState(true);

  const [classFilterList, setClassFilterList] = React.useState(null);
  const [filterProviders, setFilterProviders] = React.useState(0);
  const [filterWorkout, setFilterWorkout] = React.useState(0);

  const [filterIntensity, setFilterIntensity] = React.useState(0);
  const [filterLocations, setFilterLocations] = React.useState(0);
  const [filterDayOfWeek, setFilterDayOfWeek] = React.useState(0);
  const [filterTimeOfDay, setFilterTimeOfDay] = React.useState(0);
  const [filterAgeGroups, setFilterAgeGroups] = React.useState(0);
  const [filterGenders, setFilterGenders] = React.useState(0);

  const [filterVirtual, setFilterVirtual] = React.useState(null);
  const [filterDetermination, setFilterDetermination] = React.useState(null);

  const resetFilters = () => {
    setFilterProviders(
      (classFilterList.providers && classFilterList.providers[0]) || null
    );
    setFilterWorkout(
      (classFilterList.workout_types && classFilterList.workout_types[0]) ||
        null
    );
    setFilterIntensity(
      (classFilterList.intensity && classFilterList.intensity[0]) || null
    );
    setFilterLocations(
      (classFilterList.locations && classFilterList.locations[0]) || null
    );
    setFilterDayOfWeek(
      (classFilterList.day_of_the_week && classFilterList.day_of_the_week[0]) ||
        null
    );
    setFilterTimeOfDay(
      (classFilterList.time_of_days && classFilterList.time_of_days[0]) || null
    );
    setFilterAgeGroups(
      (classFilterList.age_groups && classFilterList.age_groups[0]) || null
    );
    setFilterGenders(
      (classFilterList.genders && classFilterList.genders[0]) || null
    );
    setFilterVirtual(null);
    setFilterDetermination(null);
    setupdateFilters(!updateFilters);
  };

  const clearFilters = () => {
    setFilterProviders(null);
    setFilterWorkout(null);
    setFilterIntensity(null);
    setFilterLocations(null);
    setFilterDayOfWeek(null);
    setFilterTimeOfDay(null);
    setFilterAgeGroups(null);
    setFilterGenders(null);
    setFilterVirtual(null);
    setFilterDetermination(null);
  };

  const checkFilterExists = (object) => {
    if (object) {
      if (
        object.age_groups !== null ||
        object.day_of_the_week !== null ||
        object.genders !== null ||
        object.intensity !== null ||
        object.is_determination !== false ||
        object.is_virtual !== false ||
        object.locations !== null ||
        object.providers !== null ||
        object.time_of_days !== null ||
        object.workout_types !== null
      )
        return true;
    }
    return false;
  };

  const filterQueries = () => {
    const filtersArray = [];
    filtersArray.push(
      `&providers=${filterProviders ? filterProviders.value : 0}`
    );
    filtersArray.push(
      `&workout_types=${filterWorkout ? filterWorkout.value : 0}`
    );
    filtersArray.push(
      `&intensity=${filterIntensity ? filterIntensity.value : 0}`
    );
    filtersArray.push(
      `&locations=${filterLocations ? filterLocations.value : 0}`
    );
    filtersArray.push(
      `&day_of_the_week=${filterDayOfWeek ? filterDayOfWeek.value : 0}`
    );
    filtersArray.push(
      `&time_of_days=${filterTimeOfDay ? filterTimeOfDay.value : 0}`
    );
    filtersArray.push(
      `&age_groups=${filterAgeGroups ? filterAgeGroups.value : 0}`
    );
    filtersArray.push(`&genders=${filterGenders ? filterGenders.value : 0}`);
    filtersArray.push(`&is_virtual=${filterVirtual ? filterVirtual : ""}`);
    filtersArray.push(
      `&is_determination=${filterDetermination ? filterDetermination : ""}`
    );
    return filtersArray.join("");
  };

  const transformOptions = (data, firstItem) => {
    if (data && data.length) {
      let list = data.map((item) => {
        return {
          value: item.id,
          label: item.title,
        };
      });
      return [
        {
          value: 0,
          label: firstItem,
        },
        ...list,
      ];
    }
    return null;
  };

  let queriesObject = qsToObject(window.location.search);
  let initialClassTypeId = queriesObject.classTypeId || null;
  initialClassTypeId =
    initialClassTypeId !== null
      ? parseInt(initialClassTypeId)
      : initialClassTypeId;
  const [selectedCat, setSelectedCat] = React.useState(null);
  let searchedText = queriesObject.searchTerm;
  let config = window.whatsonClassesConfig;

  React.useEffect(() => {
    addQueryString("WhatsOnTab", "Class");
    queriesObject = qsToObject(window.location.search);

    let searchTerm = queriesObject.searchTerm;
    let filteredDate = queriesObject.filterDate;
    if (searchTerm === undefined) {
      searchTerm = "";
    }
    if (filteredDate === undefined) {
      filteredDate = "";
    } else {
      setdate(decodeURIComponent(filteredDate));
    }
    sethideLoadMore(false);
    setshowLoader(true);
    let apiUrl = `${config.apiUrl}?classesNodeId=${
      config.classesNodeId
    }&pageNumber=${config.pageNumber}&pagesize=${config.pagesize}&classTypeId=${
      queriesObject.classTypeId || config.classTypeId
    }&culture=${config.culture}&datasourceId=${
      config.datasourceId
    }${filterQueries()}`;

    fetch(apiUrl)
      .then((result) => result.json())
      .then(
        (result) => {
          if (
            result &&
            result.sub_type_filter &&
            result.sub_type_filter.length
          ) {
            if (initialClassTypeId !== null) {
              let subType = {};
              result.sub_type_filter.map((item) => {
                if (item.id === initialClassTypeId) {
                  subType.id = initialClassTypeId;
                  subType.type = item.type;
                }
              });
              setSelectedCat(subType.type);
            } else {
              if (selectedCat === null) {
                setSelectedCat(result.sub_type_filter[0].type);
                setFilters(result.sub_type_filter[0].id, `classTypeId`);
              }
            }
          }

          setresponse(result);
          sethits(result && result.pagination && result.pagination.Results);
          // setDisplayFilters(false);

          // setupdateFilters(false)
          if (
            result &&
            result.pagination &&
            result.pagination.PageCount === 1
          ) {
            sethideLoadMore(true);
          }
          setshowLoader(false);
        },
        (error) => {
          setshowLoader(false);
          console.error(error);
        }
      );

    queriesObject = qsToObject(window.location.search);
    let ctid = queriesObject.classTypeId || config.classTypeId;

    if (classFilterList === null && !(ctid === "0" || ctid === 0)) {
      setshowLoader(true);
      let apiUrl = `${config.advanceFilterApiUrl}?datasourceId=${config.datasourceId}&classTypeId=${ctid}`;
      fetch(apiUrl)
        .then((result) => result.json())
        .then(
          (result) => {
            let newObj = result;

            if (newObj.providers && newObj.providers.length) {
              newObj.providers = transformOptions(
                newObj.providers,
                newObj.dictionary_items.Provider
              );
              setFilterProviders(newObj.providers[0]);
            } else {
              setFilterProviders(0);
            }

            if (newObj.workout_types && newObj.workout_types.length) {
              newObj.workout_types = transformOptions(
                newObj.workout_types,
                newObj.dictionary_items.WorkoutType
              );
              setFilterWorkout(newObj.workout_types[0]);
            } else {
              setFilterWorkout(0);
            }

            if (newObj.intensity && newObj.intensity.length) {
              newObj.intensity = transformOptions(
                newObj.intensity,
                newObj.dictionary_items.Intensity
              );
              setFilterIntensity(newObj.intensity[0]);
            } else {
              setFilterIntensity(0);
            }

            if (newObj.locations && newObj.locations.length) {
              newObj.locations = transformOptions(
                newObj.locations,
                newObj.dictionary_items.Locations
              );
              setFilterLocations(newObj.locations[0]);
            } else {
              setFilterLocations(0);
            }

            if (newObj.day_of_the_week && newObj.day_of_the_week.length) {
              newObj.day_of_the_week = transformOptions(
                newObj.day_of_the_week,
                newObj.dictionary_items.DayoftheWeek
              );
              setFilterDayOfWeek(newObj.day_of_the_week[0]);
            } else {
              setFilterDayOfWeek(0);
            }

            if (newObj.time_of_days && newObj.time_of_days.length) {
              newObj.time_of_days = transformOptions(
                newObj.time_of_days,
                newObj.dictionary_items.TimeofDay
              );
              setFilterTimeOfDay(newObj.time_of_days[0]);
            } else {
              setFilterTimeOfDay(0);
            }

            if (newObj.age_groups && newObj.age_groups.length) {
              newObj.age_groups = transformOptions(
                newObj.age_groups,
                newObj.dictionary_items.AgeGroup
              );
              setFilterAgeGroups(newObj.age_groups[0]);
            } else {
              setFilterAgeGroups(0);
            }

            if (newObj.genders && newObj.genders.length) {
              newObj.genders = transformOptions(
                newObj.genders,
                newObj.dictionary_items.Gender
              );
              setFilterGenders(newObj.genders[0]);
            } else {
              setFilterGenders(0);
            }

            if (newObj.is_virtual && newObj.is_virtual === true) {
              newObj.is_virtual = true;
            } else {
              newObj.is_virtual = false;
            }

            if (newObj.is_determination && newObj.is_determination === true) {
              newObj.is_determination = true;
            } else {
              newObj.is_determination = false;
            }

            setClassFilterList(newObj);
            setshowLoader(false);
          },
          (error) => {
            setshowLoader(false);
            console.error(error);
          }
        );
    }
  }, [updateFilters]);

  const loadMore = (e) => {
    e.preventDefault();

    const pageCount =
      response && response.pagination && response.pagination.PageCount;
    const NextPage =
      response && response.pagination && response.pagination.NextPage;
    let searchTerm = queriesObject.searchTerm;
    let filteredDate = queriesObject.filterDate;
    if (pageCount <= NextPage) {
      sethideLoadMore(true);
    }
    if (searchTerm === undefined) {
      searchTerm = "";
    }
    if (filteredDate === undefined) {
      filteredDate = "";
    }
    setshowLoader(true);
    let apiUrl = `${config.apiUrl}?classesNodeId=${
      config.classesNodeId
    }&pageNumber=${NextPage}&pagesize=${config.pagesize}&classTypeId=${
      queriesObject.classTypeId || config.classTypeId
    }&culture=${config.culture}${filterQueries()}`;

    fetch(apiUrl)
      .then((res) => res.json())
      .then(
        (result) => {
          setresponse(result);

          if (hits) {
            sethits(
              hits.concat(
                result && result.pagination && result.pagination.Results
              )
            );
          } else {
            sethits(result && result.pagination && result.pagination.Results);
          }
          setshowLoader(false);
        },

        (error) => {
          setshowLoader(false);
          console.error(error);
        }
      );
  };

  const setFilters = (value, filterName) => {
    addQueryString(filterName, value);
    queriesObject = qsToObject(window.location.search);
    setupdateFilters(!updateFilters);
  };

  return (
    <div>
      {showLoader && <div className="ajax-loader"></div>}

      <div className="explore-whats-on__categories">
        <ul className="explore-whats-on__category-items">
          {tabList &&
            tabList.map((item, index) => {
              if (item.hide) return null;
              // else if (index ===1) return null;
              else
                return (
                  <li
                    key={index}
                    onClick={(e) => {
                      changeTab(item);
                    }}
                    className={`explore-whats-on__category-item ${
                      item && item.active ? "active" : ""
                    }`}
                  >
                    <span className="btn btn-expended-full-color">
                      {item && item.tabName} 
                    </span>
                  </li>
                );
            })}
        </ul>
      </div>

      <div className="what-on-classes-filter__main-classes">
        <ul>
          {response &&
            response.sub_type_filter &&
            response.sub_type_filter.map((filter, index) => {
              return (
                <li
                  key={index}
                  className={` ${
                    filter &&
                    filter.id ==
                      (queriesObject.classTypeId || config.classTypeId)
                      ? "active"
                      : ""
                  }`}
                  onClick={(e) => {
                    if (
                      !(
                        filter.id ==
                        (queriesObject.classTypeId || config.classTypeId)
                      )
                    ) {
                      setClassFilterList(null);
                      clearFilters();
                      setSelectedCat(filter.type);
                      setFilters(filter.id, `classTypeId`);
                    }
                  }}
                >
                  <span
                    data-id={filter && filter.id}
                    data-type={filter && filter.id}
                  >
                    {filter && filter.title}
                  </span>
                </li>
              );
            })}
        </ul>
        {checkFilterExists(classFilterList) ? (
          <span
            className={`what-on-classes-filter__toggle ${
              displayFilters ? "active" : ""
            }`}
            onClick={() => setDisplayFilters(!displayFilters)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27.281"
              height="27.25"
              viewBox="0 0 27.281 27.25"
            >
              <g id="Group_789" data-name="Group 789" transform="translate(0)">
                <path
                  id="Path_2666"
                  data-name="Path 2666"
                  d="M1375.521,1820.111h-2.634a3.823,3.823,0,0,0-7.205,0h-14.838a1.3,1.3,0,0,0,.032,2.6h14.836a3.825,3.825,0,0,0,7.207,0h2.634a1.293,1.293,0,0,0,1.3-1.3A1.338,1.338,0,0,0,1375.521,1820.111Z"
                  transform="translate(-1349.572 -1807.788)"
                />
                <path
                  id="Path_2667"
                  data-name="Path 2667"
                  d="M1375.521,1826.345h-15.078a3.825,3.825,0,0,0-7.207,0h-2.36a1.287,1.287,0,1,0,0,2.574h2.392a3.767,3.767,0,0,0,3.572,2.543,3.836,3.836,0,0,0,3.6-2.543h15.078a1.287,1.287,0,1,0,0-2.574Z"
                  transform="translate(-1349.572 -1804.213)"
                />
                <path
                  id="Path_2668"
                  data-name="Path 2668"
                  d="M1350.875,1816.47h8.719a3.825,3.825,0,0,0,7.207,0h8.719a1.3,1.3,0,1,0,0-2.6H1366.8a3.832,3.832,0,0,0-7.207.03h-8.719a1.287,1.287,0,1,0,0,2.574Z"
                  transform="translate(-1349.572 -1811.353)"
                />
              </g>
            </svg>
          </span>
        ) : null}
      </div>

      {checkFilterExists(classFilterList) && displayFilters ? (
        <div className="what-on-classes-filter__main-filters">
          <div className="row">
            <div className="col-8">
              <div className="row">
                {classFilterList.providers &&
                classFilterList.providers.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterProviders}
                        value={filterProviders}
                        onChange={(e) => {
                          setFilterProviders(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.providers}
                      />
                    </div>
                  </div>
                ) : null}

                {classFilterList.workout_types &&
                classFilterList.workout_types.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterWorkout}
                        value={filterWorkout}
                        onChange={(e) => {
                          setFilterWorkout(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.workout_types}
                      />
                    </div>
                  </div>
                ) : null}

                {classFilterList.intensity &&
                classFilterList.intensity.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterIntensity}
                        value={filterIntensity}
                        onChange={(e) => {
                          setFilterIntensity(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.intensity}
                      />
                    </div>
                  </div>
                ) : null}

                {classFilterList.locations &&
                classFilterList.locations.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterLocations}
                        value={filterLocations}
                        onChange={(e) => {
                          setFilterLocations(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.locations}
                      />
                    </div>
                  </div>
                ) : null}

                {classFilterList.day_of_the_week &&
                classFilterList.day_of_the_week.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterDayOfWeek}
                        value={filterDayOfWeek}
                        onChange={(e) => {
                          setFilterDayOfWeek(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.day_of_the_week}
                      />
                    </div>
                  </div>
                ) : null}

                {classFilterList.time_of_days &&
                classFilterList.time_of_days.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterTimeOfDay}
                        value={filterTimeOfDay}
                        onChange={(e) => {
                          setFilterTimeOfDay(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.time_of_days}
                      />
                    </div>
                  </div>
                ) : null}

                {classFilterList.age_groups &&
                classFilterList.age_groups.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterAgeGroups}
                        value={filterAgeGroups}
                        onChange={(e) => {
                          setFilterAgeGroups(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.age_groups}
                      />
                    </div>
                  </div>
                ) : null}

                {classFilterList.genders && classFilterList.genders.length ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="input-group select-dropdown">
                      <Select
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={filterGenders}
                        value={filterGenders}
                        onChange={(e) => {
                          setFilterGenders(e);
                          setupdateFilters(!updateFilters);
                        }}
                        options={classFilterList.genders}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="col">
              <div className="row">
                <div className="col">
                  {classFilterList.is_virtual &&
                  classFilterList.is_virtual === true ? (
                    <div className="radio-pack">
                      <p className="lable-pra">
                        {classFilterList.dictionary_items.VirtualClass}
                      </p>
                      <div className="d-flex">
                        <label className="radio-container">
                          {classFilterList.dictionary_items.FilterYes}
                          <input
                            type="radio"
                            name="radio-virtual"
                            onChange={() => {
                              setFilterVirtual(true);
                              setupdateFilters(!updateFilters);
                            }}
                            checked={filterVirtual === true ? true : false}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="radio-container">
                          {classFilterList.dictionary_items.FilterNo}
                          <input
                            type="radio"
                            name="radio-virtual"
                            onChange={() => {
                              setFilterVirtual(false);
                              setupdateFilters(!updateFilters);
                            }}
                            checked={filterVirtual === false ? true : false}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    </div>
                  ) : null}

                  {classFilterList.is_determination &&
                  classFilterList.is_determination === true ? (
                    <div className="radio-pack">
                      <p className="lable-pra">
                        {classFilterList.dictionary_items.Determination}
                      </p>
                      <div className="d-flex">
                        <label className="radio-container">
                          {classFilterList.dictionary_items.FilterYes}
                          <input
                            type="radio"
                            name="radio-determine"
                            onChange={() => {
                              setFilterDetermination(true);
                              setupdateFilters(!updateFilters);
                            }}
                            checked={
                              filterDetermination === true ? true : false
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="radio-container">
                          {classFilterList.dictionary_items.FilterNo}
                          <input
                            type="radio"
                            name="radio-determine"
                            onChange={() => {
                              setFilterDetermination(false);
                              setupdateFilters(!updateFilters);
                            }}
                            checked={
                              filterDetermination === false ? true : false
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-auto reset-filter">
                  <button
                    type="button"
                    className="btn btn-expended-full-color"
                    onClick={resetFilters}
                  >
                    {classFilterList.dictionary_items.ResetFilter}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="explore-whats-on__grid">
        {selectedCat === "classesDetail" ? (
          <div className="what-on-classes-filter">
            <div className="what-on-classes">
              <div className="row">
                {hits &&
                  hits.map((item, index) => {
                    return (
                      <div
                        key={index}
                        data-end-date={item && item.event_end_date}
                        data-start-date={item && item.event_start_date}
                        className="col-4"
                      >
                        <div className="deals-offers__wrap">
                          <div className="deals-offers__item">
                            <div className="masonry__category">
                              {response &&
                                response.dictionary_items &&
                                response.dictionary_items.TagClass}
                            </div>
                            <div className="deals-offers__image unlocked">
                              <a
                                href={item && item.detail_page_url}
                                className="deals-offers__image-link"
                              >
                                <img
                                  src={
                                    (item && item.image) ||
                                    "/Common/images/placeholder.jpg"
                                  }
                                  alt=""
                                />
                              </a>
                            </div>
                          </div>
                          <div className="deals-offers__info">
                            <div className="deals-offers__info-category">
                              {item && item.tag}
                            </div>
                            <h4 className="deals-offers__info-title">
                              {item && item.title}
                            </h4>

                            <a
                              href={item && item.detail_page_url}
                              className="btn btn-expended-full-color"
                            >
                              {response &&
                                response.dictionary_items &&
                                response.dictionary_items.SeeClass}
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        ) : null}
        {selectedCat === "villageHub" ? (
          <div className="masonry__grid">
            <div className={"grid-events grid"}>
              {hits &&
                hits.map((item, index) => {
                  return (
                    <a
                      key={index}
                      href={item && item.detail_page_url}
                      target="_blank"
                      className={`grid-item`}
                    >
                      <div className="masonry__item">
                        {/* <div className="masonry__category">
                        {item && item.event_type_text || item.article_type_text}
                      </div> */}
                        <div className="masonry__image">
                          <img
                            src={
                              (item && item.image) ||
                              "/Common/images/placeholder.jpg"
                            }
                            alt="image"
                          />
                        </div>
                        <div className="masonry__content">
                          <h6 className="masonry__sub-heading">
                            {(item && item.tag) || item.location}
                          </h6>
                          <h4 className="masonry__heading">
                            {item && item.title}
                          </h4>
                          <div className="masonry__extras">
                            {/* <p className="masonry__para">{item && item.summary || item.description} </p> */}
                            <div className="masonry__btns">
                              <a
                                href={item && item.booking_url}
                                target="_blank"
                                className="btn btn-rounded btn-rounded-white masonry__btn"
                              >
                                {response &&
                                  response.dictionary_items &&
                                  response.dictionary_items["Book-Now"]}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  );
                })}
            </div>
          </div>
        ) : null}
        {selectedCat === "studioTV" ? (
          <div className="what-on-classes-filter">
            <div className="what-on-classes what-on-classes-2">
              <div className="row">
                {hits &&
                  hits.map((item, index) => {
                    return (
                      <div
                        key={index}
                        data-end-date={item && item.event_end_date}
                        data-start-date={item && item.event_start_date}
                        className="col-4"
                      >
                        <div className="deals-offers__wrap deals-offers__wrap--2">
                          <div className="deals-offers__item">
                            <div className="deals-offers__image unlocked">
                              <img
                                src={
                                  (item && item.image) ||
                                  "/Common/images/placeholder.jpg"
                                }
                                alt="Image"
                              />
                            </div>

                            <div className="deals-offers__status">Live</div>
                          </div>
                          <div className="deals-offers__info">
                            <h4 className="deals-offers__info-title">
                              <a
                                href={item && item.detail_page_url}
                                target="_blank"
                              >
                                {item && item.title}
                              </a>
                            </h4>
                            {/* <h5 className="deals-offers__info-code">USE PROMO CODE: <strong>DFC30X30</strong></h5> */}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {hits && hits.length === 0 && (
        <div className="no-results">
          <div className="container">
            <div className="row">
              <div className="col-10 offset-md-1">
                <h2>
                  {response &&
                    response.dictionary_items &&
                    response.dictionary_items.EventResultNotFound}
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
      {!hideLoadMore && hits && hits.length !== 0 && (
        <div className="explore-whats-on__buttons">
          <span
            onClick={(e) => {
              loadMore(e);
            }}
            className="btn btn-expended-full-color"
          >
            {response &&
              response.dictionary_items &&
              response.dictionary_items.LoadMore}
          </span>
        </div>
      )}
    </div>
  );
};

export default WhatsOnListingClasses;
